<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">积分明细</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
    <!-- 积分明细顶部  开始 -->
    <div class="page_topmine">
      <div class="jifen_detail">
        <div class="jifen_num">{{amount}}</div>
        <div class="jifen_text">当前积分</div>
      </div>
    </div>
    <!-- 积分明细顶部  结束 -->
    <!-- 积分明细列表  开始 -->
    <div class="page_taocan jifen_List">
      <div class="mingxi_detail_box" v-for="(item,index) in accountlog">
        <div class="mingxi_detail_box_left">
          <div class="mingxi_detail_text">{{item.note}}</div>
          <div class="mingxi_detail_time">{{item.created_at_str}}</div>
        </div>
        <div class="mingxi_detail_box_right">{{item.change_amount}}</div>
      </div>
      <div @click="getMore()" class='jifen_label more' v-if="datalengthX">查看更多</div>

      <!--      <div class="jiaoyi_none_center" v-if="accountlog.length==0">
        <div class="jiaoyi_noneimg">
          <img src="/static/jiaoyi.png" class="none_icon" />
        </div>
        <div class="jiaoyi_none">暂无交易明细</div>
      </div> -->
    </div>
    <!-- 暂无信息 开始 -->
    <div class="page_taocan jifen_List1" v-if="accountlog.length==0">
      <div class="mingxi_none">
        <img src="/static/newprojecticon/zanwujilu.png" class="mingxi_none_icon" />
      </div>
    </div>
    <!-- 暂无信息  结束 -->
    <!-- 积分明细列表  结束 -->
  </div>

</template>

<script>
  import httper from '../../api/http';

  export default {
    data() {
      return {
        amount: "", //用户总积分
        accountlog: [], //积分明细
        datalengthX: false, //判断是否要继续请求订单列,默认值false
        pages: 1, //判断是否要继续请求订单的第几页数,默认值1
        page_size: 6,
      }
    },
    created() {
      this.request("getUserInfo")
      this.request("getAccountLog", {
        page: 1,
        page_size: 6
      })
    },
    mounted() {

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      toReturn() {
        this.$router.go(-1)
      },
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code === 0) {
                let userinfo = res.data
                console.log('userinfo', userinfo)
                // sessionStorage.setItem('userinfo', JSON.stringify(userinfo))
                //that.phoneNum = userinfo.mobile ? userinfo.mobile : 'meiyou'
                that.amount = userinfo.account.amount
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //获取积分日志
          case 'getAccountLog':
            httper.get('/user/account-log', requestData, res => {
              if (res.code === 0) {
                console.log("res", res)
                let lengthX = res.data.length - this.page_size === 0 //判断列是否20条
                that.datalengthX = lengthX
                if (res.data.length > 0) {
                  let accountlog = that.accountlog;
                  for (let i = 0; i < res.data.length; i++) {
                    accountlog.push(res.data[i]);
                  }
                  that.accountlog = accountlog
                }
                // this.accountlog = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break

        }
      },
      //查看更多
      getMore() {
        let that = this
        console.log("获取更多")
        if (!that.datalengthX) {
          this.$toast({
            message: '没有更多了'
          })
          return
        }
        let page = (that.pages) + 1
        that.pages = page
        this.request("getAccountLog", {
          page: page,
          page_size: this.page_size
        })
      },
    }
  }
</script>

<style>
  .jifen_detail {
    height: 113px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .jifen_num {
    font-size: 26px;
    font-weight: 400;
    color: rgba(247, 247, 247, 1);
    margin-bottom: 10px;

  }

  .jifen_text {
    font-size: 13px;
    font-weight: 400;
    color: rgba(247, 247, 247, 1);
  }

  .jifen_List {
    height: auto;
    top: -50px;
    padding: 10px;
  }

  .jifen_List1 {
    height: 450px;
 /*   top: 133px; */
  }

  .mingxi_none {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .mingxi_none_icon {
   /* width: 140px;
    height: 140px; */
	width: 85px;
	 height: 120px;
  }

  .mingxi_detai_list {
    /* margin: 20px; */
    border: 1px solid #dedede;
  }

  .mingxi_detail_box {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dedede;
    align-items: center;
  }

  .mingxi_detail_box_left {}

  .mingxi_detail_text {
    font-weight: bold;
  }

  .mingxi_detail_time {
    color: #828181;
  }

  .mingxi_detail_box_right {
    font-weight: bold;
    color:#FD8C00;
  }

  .jifen_label {
    margin: 20px 15px 0;
    display: block;
    text-align: center;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .more {
    padding: 10px 0;
    text-align: center;
    font-size: 15px;
    border: 1px solid #E3E3E3;
    box-shadow: 0 3px 3px #E3E3E3;
    color: orange;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/jifenList/jifenmingxi.vue